import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const CategoryCard = ({ category }) => {
  const { name, slug, image_url } = category;

  return (
    <Link
      to={`/produkter?category=${category.id}`}
      className="group relative block overflow-hidden rounded-xl"
      style={{
        boxShadow: '0 4px 20px -4px rgba(0,0,0,0.08), 0 8px 32px -8px rgba(0,0,0,0.04)',
      }}
      data-testid={`category-card-${slug}`}
    >
      {/* Image with consistent aspect ratio */}
      <div className="aspect-[4/3] relative overflow-hidden">
        {/* Background image */}
        <img
          src={image_url}
          alt={name}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
          loading="lazy"
        />
        
        {/* Dark overlay for text contrast */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/25 to-transparent" />
        
        {/* Hover overlay */}
        <div className="absolute inset-0 bg-[#0B1E33]/0 group-hover:bg-[#0B1E33]/20 transition-colors duration-300" />
        
        {/* Content positioned at bottom */}
        <div className="absolute inset-0 flex flex-col justify-end p-4 md:p-5">
          {/* Category name - responsive text size for longer names */}
          <h3 
            className="text-white text-sm md:text-base lg:text-lg leading-tight mb-1 transition-transform duration-300 group-hover:translate-x-1"
            style={{ 
              fontFamily: 'var(--font-heading)', 
              fontWeight: 700,
              textShadow: '0 2px 8px rgba(0,0,0,0.4)'
            }}
          >
            {name}
          </h3>
          
          {/* View link with arrow */}
          <div className="flex items-center gap-1.5 text-white/80 text-xs font-medium opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-2 group-hover:translate-y-0">
            <span>Utforska</span>
            <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
          </div>
        </div>
      </div>
    </Link>
  );
};
